var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cert-docs",domProps:{"innerHTML":_vm._s(_vm.certificatePurchase)}})
}
var staticRenderFns = []

export { render, staticRenderFns }